module.exports = __webpack_public_path__ + "static/F3_deal_bg-07c11027cb10ac0ee9665ccc8e35e788.png";